import React from 'react';
import PropTypes from 'prop-types';
import {LabelIndex} from '../LabelIndex';
import {Label} from '../Label';
import {OptionFeedback} from '../OptionFeedback';

const CLASS_NAME = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
  INVALID: 'invalid',
  SELECTED: 'selected-color',
  NONE: '',
};
const SHAPE = 'square';

/**
 * The Checkbox component to be displayed for MSCQ [MultiSelect Component]
 */
export function MultiSelectCheckbox(props) {
  const selectOption = (event) => {
    event.preventDefault();
    if (props.disabled === false) {
      props.selectOption({
        componentID: props.componentID,
        optionID: props.id,
        checked: !props.selected,
      });
    }
  };

  const wrapperClass = () => `${props.className} ${setOptionStateClassName()}`;

  const setOptionStateClassName = () => {
    if (props.selected && props.disabled && !props.isCorrect)
      return CLASS_NAME.INCORRECT;
    else if (props.disabled && props.isCorrect) return CLASS_NAME.CORRECT;
    else if (props.disabled && !props.selected) return CLASS_NAME.INVALID;
    else if (props.selected) return CLASS_NAME.SELECTED;
    else return CLASS_NAME.NONE;
  };

  const getFeedbackClassName = () =>
    props.isCorrect ? CLASS_NAME.CORRECT : CLASS_NAME.INCORRECT;

  return (
    <>
      <div className={wrapperClass()} onClick={selectOption}>
        <LabelIndex
          id={props.id}
          shape={SHAPE}
          selected={props.selected}
          disabled={props.disabled}
          isCorrect={props.isCorrect}
        />
        <Label label={props.text} />
      </div>
      <OptionFeedback
        visible={props.disabled}
        type={getFeedbackClassName()}
        text={props.feedback}
      />
    </>
  );
}

MultiSelectCheckbox.propTypes = {
  /**
   * Custom className to be set on component
   */
  className: PropTypes.string,
  /**
   * ComponentID for which the option belongs to
   */
  componentID: PropTypes.number.isRequired,
  /**
   * The feedback to be displayed for the particular option
   */
  feedback: PropTypes.string,
  /**
   * ID for the particular prop
   */
  id: PropTypes.number.isRequired,
  /**
   * Boolean value specifying if the option is correct
   */
  isCorrect: PropTypes.bool.isRequired,
  /**
   * Boolean value specifying if the checkbox is selected
   */
  selected: PropTypes.bool,
  /**
   * Text to be displayed for the checkbox
   */
  text: PropTypes.string,
  /**
   * Boolean value specifying if the checkbox is disabled
   */
  disabled: PropTypes.bool.isRequired,
  /**
   * Callback function to be involked when updating checkbox state
   */
  selectOption: PropTypes.func.isRequired,
};

MultiSelectCheckbox.defaultProps = {};
